import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import { theme } from './theme/theme';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ShopsPage from './pages/ShopsPage';
import ProductsPage from './pages/ProductsPage';
import TablesPage from './pages/TablesPage';
import CategoriesPage from './pages/CategoriesPage';
import ShopOwnersPage from './pages/ShopOwnersPage';
import AgentsPage from './pages/AgentsPage';
import RestaurantOrderPage from './pages/RestaurantOrderPage';
import CostCalculatorPage from './pages/CostCalculatorPage';
import Layout from './components/Layout';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Layout />
                </PrivateRoute>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route
                path="shops"
                element={
                  <AdminRoute>
                    <ShopsPage />
                  </AdminRoute>
                }
              />
              <Route
                path="shops/:shopId/products"
                element={
                  <AdminRoute>
                    <ProductsPage />
                  </AdminRoute>
                }
              />
              <Route
                path="shops/:shopId/tables"
                element={
                  <AdminRoute>
                    <TablesPage />
                  </AdminRoute>
                }
              />
              <Route
                path="shops/:shopId/categories"
                element={
                  <AdminRoute>
                    <CategoriesPage />
                  </AdminRoute>
                }
              />
              <Route
                path="shops/:shopId/shop-owners"
                element={
                  <AdminRoute>
                    <ShopOwnersPage />
                  </AdminRoute>
                }
              />
              <Route
                path="agents"
                element={
                  <AdminRoute>
                    <AgentsPage />
                  </AdminRoute>
                }
              />
              <Route path="restaurant-order" element={<RestaurantOrderPage />} />
              <Route path="cost-calculator" element={<CostCalculatorPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
